import React from "react";

export default function ViewAppraisal({ closeModal, employee, eventName }) {
  return (
    <React.Fragment>
      <h3 className="modal-title" style={{ color: "#000" }}>
        {employee.first_name.toUpperCase()} {employee.last_name.toUpperCase()}{" "}
      </h3>
      <hr />

      <div>
        <h4 className="modal-title" style={{ color: "#000" }}>
          {eventName}
        </h4>
      </div>
      <div className="pt-3">
        <p>Employee has not been appraised yet</p>
      </div>
      <div className="form-group row">
        <div className="col">
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
        <div className="col-md-10">
          {/* <button
            type="submit"
            className="btn btn-block nt-button-color-default btn-sm"
          >
            Save{" "}
            {isSubmitting ? (
              <span id="login_spinner" className="fa fa-spin fa-spinner"></span>
            ) : null}
          </button> */}
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/modals/viewAppraisal.js